<template>
  <v-container fluid pa-0 dark flat my-5>
    <div class="overlay-loading" v-if="loadingPedido">
    		<LoadingLogo/>
    		<h3>Estamos procesando tu solicitud.</h3>
	 	</div>
    <v-layout row wrap class="inner-container" justify-center mx-auto>
			<v-flex xs12 justify-center>
				<h1 class="mb-2">Bienvenido {{ usuario.nombre }}</h1>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>
  <!--   <v-toolbar>
      <v-toolbar-items>
        <v-btn flat @click="selected = 'Mis Datos'">Mis Datos</v-btn>
        <v-btn flat @click="loadingMudanzas">Mis Mudanzas</v-btn>
        <v-btn flat @click="loadingFletes">Mis Fletes</v-btn>
      </v-toolbar-items>
    </v-toolbar> -->
    <v-tabs fixed-tabs>
      <v-tab @click="selected = 'Mis Datos'">Mis Datos</v-tab>
      <!-- <v-tab @click="loadingMudanzas">Mis Mudanzas</v-tab> -->
      <v-tab @click="sortFletes()">Mis Pedidos</v-tab>
      <v-tab :to="{ name: 'contacto' }">Nuevo Pedido</v-tab>
    </v-tabs>
    <v-layout v-if="selected === 'Mis Datos'" justify-center>
      <v-flex xs6 sm12 md4 justify-center px-2>
          <hr>
          <h3>Datos personales</h3>
          <br>
          <p class="mb-1"><b>Nombre: </b> {{ usuario.nombre }} </p>
          <p class="mb-1"><b>Email: </b> {{ usuario.email }}</p>
          <p class="mb-1"><b>Direccion: </b> {{ usuario.direccion }},{{ usuario.comuna }}, {{ usuario.ciudad }}</p>
          <p class="mb-1"><b>Teléfono: </b> {{ usuario.telefono }}</p>
          <hr>
          <h3>Datos Empresa</h3>
          <br>
          <p class="mb-1"><b>Giro Comercial: </b>{{usuario.giroComercial}}</p>
          <p class="mb-1"><b>Razón Social: </b>{{usuario.razonSocial}}</p>
          <p class="mb-1"><b>R.U.T: </b> {{usuario.rut}} </p>
          <hr>
          <div v-if="usuario.tipoCliente === 'Convenio' && usuario.descuento && usuario.activoTramos === true">
            <p  class="mb-1"><h3>Descuentos</h3> <b>Porcentaje Descuento: </b>-{{ usuario.descuento }}% </p>
          </div>
          <div v-if="usuario.descuentoEspecial && usuario.activoTramos">
            <h3>Descuentos Especiales: </h3>
            <br>
            <div v-for="(item, index) in usuario.descuentoEspecial" :key="index">
              <p><b>Categoria: </b>{{ getCategory(item.category) }} || <b>Descuento: </b>-{{ item.descuento + usuario.descuento }}%</p>
            </div>
            <hr>
          </div>
          <p v-if=" usuario.fechaFacturacion && usuario.fechaFacturacion !== ''" class="mb-1"><b>Fecha Facturación: </b> Día {{usuario.fechaFacturacion}} de cada més.</p>
          <p v-else class="mb-1" style="color: red;"><b>Favor ingresar fecha de facturación en "Editar Datos"</b></p>
          <br>
          <v-btn v-if="!editarDatos && !cambiaContrasena" color="info" @click="!editarDatos ? editarDatos = true : editarDatos = false">Editar Datos</v-btn>
          <v-btn v-if="!cambiaContrasena && !editarDatos" color="info" @click="!cambiaContrasena ? cambiaContrasena = true : cambiaContrasena = false">Cambiar Contraseña</v-btn>
          <v-btn v-if="!editarDatos && !cambiaContrasena" color="info" @click="!addCC ? addCC = true : addCC = false">Añadir Correo</v-btn>
          <v-btn v-if="editarDatos" color="error" @click="!editarDatos ? editarDatos = true : editarDatos = false">Cancelar</v-btn>
          <v-btn v-if="cambiaContrasena" color="error" @click="!cambiaContrasena ? cambiaContrasena = true : cambiaContrasena = false">Cancelar</v-btn>
      </v-flex>
      <v-flex v-if="editarDatos" xs6 sm12 md4 justify-center px-2>
        <h1>Datos a editar</h1> 
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.nombre" label="Nombre y Apellido" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.telefono" label="Teléfono" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.email" label="Email" required :rules="rules.emailRules"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.rut" label="R.U.T" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.razonSocial" label="Razon Social" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.giroComercial" label="Giro Comercial" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.direccion" label="Dirección" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.comuna" label="Comuna" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field v-model="data.ciudad" label="Ciudad" required :rules="rules.required"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-select
            v-model="data.fechaFacturacion"
            :items="dias"
            :rules="rules.required"
            append-icon="fas fa-caret-down"
            label="Día de Facturación"
          ></v-select>
        </v-flex>
        <v-btn color="info" @click="updateInfo">Actualizar Datos</v-btn>
      </v-flex>
      <v-flex v-if="cambiaContrasena && !editarDatos"  xs6 sm12 md4 justify-center px-2>
        <h3>Cambiar Contraseña</h3>
        <br>
        <v-flex xs12 sm6 md6>
          <v-text-field
            v-model="data.passwordActual"
            :append-icon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
            :rules="rules.required"
            :type="show ? 'text' : 'password'"
            label="Contraseña Actual"
            @click:append="show = !show"
          ></v-text-field>
          <v-text-field
            v-model="data.password1"
            :append-icon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
            :rules="rules.required"
            :type="show ? 'text' : 'password'"
            label="Contraseña Nueva"
            @click:append="show = !show"
          ></v-text-field>
          <v-text-field
            v-model="data.password2"
            :append-icon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
            :rules="rules.required"
            :type="show ? 'text' : 'password'"
            label="Repetir Nueva Contraseña"
            @click:append="show = !show"
          ></v-text-field>
          <v-btn color="info" :disabled="data.passwordActual != usuario.password || data.password1 === '' || data.password1 != data.password2" @click="updatePassword">Cambiar Contraseña</v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- <v-layout v-if="selected === 'Mis Mudanzas'">
      <v-flex v-if="mudanzaExists" v-html="table"/> 
      <v-flex v-else xs6 sm12 md6 justify-center px-2>
        <h1>No tiene Mudanzas registradas</h1>
        <br>
        <h3>¿Quieres Cotizar una Mudanza? haz click en el siguiente botón para cotizar:</h3>
        <br>
        <v-btn color="info" class="py-2 my-0 p btn-content-left" block :to="{ name: 'mudanza' }">Hogar y Mudanzas</v-btn>
        <br>
      </v-flex>
    </v-layout> -->
    <v-layout v-if="selected === 'Mis Fletes'" justify-center>
      <v-flex v-if="fleteExists">
        <v-data-table
          :headers="headers"
          :hide-actions= "true"
          :items="fletes"
          class="elevation-1">
          <template slot="items" scope="props">
            <td style="padding: 0px 0px"><v-btn mini flat color="primary" @click="viewDetails(props.item)">{{ props.item.nsFormateado }}</v-btn></td>
            <td style="padding: 0px 5px">{{  setState(props.item) }}</td>
            <td style="padding: 0px 5px">{{ props.item.fecha_servicio_obj ? props.item.fecha_servicio_obj.toDate().toLocaleString() : '' }}</td>
            <!-- <td>{{ props.item.direcciones.origen }}</td> -->
            <td>{{ props.item.direcciones.destino }}</td>
            <td style="padding: 0px 0px">{{ props.item.detalleCalculosValores && props.item.detalleCalculosValores.precioFinal ? props.item.detalleCalculosValores.precioFinal : 0 | CLP }}</td>

            <td v-if="props.item.valorBase === 0" style="padding: 0px 0px">Sin precio definido.</td>
            <td v-else-if="!props.item.pagadoTotal" style="padding: 0px 0px"><v-btn color="blue darken-1" mini flat @click="openWindow(props.item.id, props.item.clienteID)">Pendiente</v-btn></td>
            <td v-else-if="props.item.pagadoTotal" style="padding: 0px 0px"><v-btn color="blue darken-1" mini flat @click="openWindow(props.item.id, props.item.clienteID)">Pagado</v-btn></td>

            <td v-if="props.item.facturaPrepago && props.item.facturaPrepago.factura && props.item.facturaPrepago.numeroDocumento" style="padding: 0px 0px"><v-btn color="blue darken-1" mini flat @click="openFactura(props.item.facturaPrepago.factura)">Factura {{ props.item.facturaPrepago.numeroDocumento }}</v-btn></td>
            <td v-else style="padding: 0px 0px">Sin Factura</td>

            <td style="padding: 0px 0px"><v-btn color="blue darken-1" mini flat @click="openDocs(props.item.id)">Ver</v-btn></td>

            <td v-if="props.item.estado === 'Registrado'" style="padding: 0px 0px"><v-btn color="blue darken-1" mini flat @click="otherWayToClone(props.item)">Repetir</v-btn></td>
            <td v-else style="padding: 0px 0px">No Disponible</td>
            <!-- <td><v-btn color="blue darken-1" flat @click="viewDetails(props.item)">Datos y Progreso</v-btn></td> -->
          </template>
        </v-data-table>
      </v-flex>
      <v-flex v-else xs6 sm12 md6 justify-center px-2>
        <h1>No tiene Fletes registrados</h1>
        <br>
        <h3>¿Quieres Cotizar un Pedido? contactate con nosotros por medio del siguiente botón:</h3>
        <br>
        <v-btn color="info" class="py-2 my-0 p btn-content-left" block :to="{ name: 'contacto' }">Negocios y Otros</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-dialog v-model="addCC" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <v-toolbar color="#1f97b9" dark>
              <v-toolbar-title>Correos de recepcion de información (5 Máximo)</v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-card-text v-if="usuario.correoCopia.length > 0"> 
            <div v-for="(correo, index) in usuario.correoCopia" :key="index">
              <p color="primary"> {{ correo }} <v-btn color="error" @click="deleteCorreo(correo, index)">Eliminar</v-btn></p> 
            </div>
          </v-card-text>
          <v-card-text v-else>
            <p><b>No hay correos registrados.</b></p>
          </v-card-text>
          <v-card-text v-if="newCorreo">
            <v-text-field
                v-model="textCorreoNuevo"
                :rules="rules.emailRules"
                label="Email"
                required
              ></v-text-field>
              <v-btn color="info" :disabled="!checkCorreo" @click="saveCorreoExtra()">Guardar</v-btn>
          </v-card-text>
          <v-card-text>
            <v-btn v-if="usuario.correoCopia.length < 5 && !newCorreo" color="info" @click="!newCorreo ? newCorreo = true : newCorreo = false">Añadir Correo</v-btn>
          </v-card-text>
          <v-card-text>
            <v-btn color="error" @click="addCCClose()">Cerrar</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout>
      <v-dialog v-model="dialogDetallesCliente" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <v-toolbar color="#1f97b9" dark>
              <v-toolbar-title>Detalle Pedido</v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-card-text v-if="pedido.estado === 'Registrado'"> 
            <v-btn  color="primary" @click="prepareCloneService"> Repetir Servicio </v-btn>
          </v-card-text>
          <v-card-text v-if="pedido.transportista">
            <h3>Datos transportista</h3>
            <br>
            <p><b>Nombre: </b> {{ pedido.transportista.conductor_data.datos.nombres + ' ' + pedido.transportista.conductor_data.datos.apellidos }}</p>
            <p><b>R.U.T: </b>{{ pedido.transportista.conductor_data.datos.rut }}</p>
            <p><b>Patente: </b> {{ pedido.transportista.datos.patente }}</p>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text>
            <p><b>Solicitud: </b> {{pedido.mensaje}} </p> 
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text>
            <p><b>Condiciones DUO: </b> {{ pedido.condiciones }}</p>
            <v-divider></v-divider>
          </v-card-text>
          <!-- <v-card-text v-if="pedido.docCliente">
            <div>
              <p>Documentos Cliente: </p>
              <div v-for="(documento, index) in pedido.docCliente" :key="index">
                <v-btn  color="primary" @click="viewDoc(documento)">Ver Documento {{ index + 1}} </v-btn>
              </div>
            </div>
            <br>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text v-else>
            <p><b>Aun no se dispone de documentos.</b></p>
          </v-card-text>
          <v-card-text v-if="pedido.servicePhotos">
            <div>
              <br>
              <p>Documentos de servicio: </p>
              <div v-for="(documento, index) in pedido.servicePhotos" :key="index">
                <p>Documento: {{ documento.nombre }}</p><v-btn flat color="primary" @click="viewDoc(documento.url)">Ver Archivo</v-btn>
              </div>
            </div>
            <br>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text v-else>
            <p><b>Aun no se disponen de documentos de servicio.</b></p>
          </v-card-text>
          <v-card-text v-if="servicePhotos && servicePhotos.servicePhotos">
            <div>
              <br>
              <p>Documentos de servicio: </p>
              <div v-for="(documento, index) in servicePhotos.servicePhotos" :key="index">
                <p>Documento: {{ documento.nombre }}</p><v-btn flat color="primary" @click="viewDoc(documento.url)">Ver Archivo</v-btn>
              </div>
            </div>
            <br>
            <v-divider></v-divider>
          </v-card-text> -->
          <v-card-text v-if="pedido.facturaPrepago">
            <br>
            <p>Factura DUO: </p><v-btn color="primary" @click="viewDoc(pedido.facturaPrepago.factura)">Ver Factura</v-btn>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text v-else>
            <br>
            <p><b>Estamos trabajando para poder disponer de la factura correspondiente.</b></p>
          </v-card-text>
          <v-card-text v-if="!pedido.progreso">
            <p>No hay progreso registrado</p>
          </v-card-text>
          <v-card-text v-else>
            <p>Progreso Servicio: </p>
             <div
              v-for="(el, index) in pedido.progreso"
              :key="index"
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                border-bottom: 1px solid #cacaca;
                margin-bottom: 3px;
                ">
              <p>{{ el.estado }}</p>
              <p>{{ el.date.toDate() | dateFromTimestamp }}</p>
            </div>
          </v-card-text>
          <!-- <div v-if="pedido.locationProgress"> -->
            <v-card-text v-if="pedido.locationProgress">
              <p>Ubicación Actual</p>
              <GmapMap
                :center="{lat: pedido.locationProgress.latitude, lng: pedido.locationProgress.longitude}"
                :zoom="15"
                style="width: 100%; height: 150px"
              >
                <GmapMarker
                  :position="{lat: pedido.locationProgress.latitude, lng: pedido.locationProgress.longitude}"
                  :clickable="false"
                  :draggable="false"
                  :icon="markerOptions"
                />
              </GmapMap>
            </v-card-text>
          <!-- </div> -->
          <v-btn color="blue darken-1" flat @click="dialogDetallesCliente = false">Cerrar</v-btn>
        </v-card>
        
      </v-dialog>
      <v-dialog v-model="dialogCloneService" max-width="600px">
        <v-card>
          <v-card-title>
            <v-toolbar color="#1f97b9" dark>
              <v-toolbar-title>¿Desea replicar el mismo servicio?</v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-textarea
                name="input-7-1"
                label="Mensaje"
                placeholder="¿Qué necesita transportar?"
                v-model="cloneDescription"
                required
                ></v-textarea>
            <v-menu
                ref="menuDate"
                :close-on-content-click="true"
                v-model="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                class="mb-5"
                padding-left="100px">
              <v-text-field
                slot="activator"
                v-model="fecha"
                label="Seleccione Fecha"
                color="#1f97b9"
                readonly
                :rules="rules.nameRules">
                <img :src='require("../../assets/static/img/fecha.png")' alt="icono de fecha" style="width: 25px;height:25px;" slot="prepend">
              </v-text-field>
              <v-date-picker
                v-model="fecha"
                :min="today"
                no-title
                scrollable
                prev-icon="fas fa-chevron-left caption"
                next-icon="fas fa-chevron-right caption"
                locale="es-mx"
                first-day-of-week="1"
                style="min-height: 400px;"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu = false">Cancelar</v-btn>
              </v-date-picker>
            </v-menu>
              <div class="hour-picker-container" xs12 md4 px-2>
              <img :src='require("../../assets/static/img/hora.png")' alt="icono de hora" style="width: 25px;height:25px;">
              <v-select
                v-model="hora"
                :items="horas"
                :rules="rules.nameRules"
                append-icon="fas fa-caret-down"
                label="Seleccione Hora"
              ></v-select>
            </div>
          </v-card-text>
          <v-card-text v-if="usuario.activoTramos">
            <v-select
                v-model="categoria"
                :items="mantenedores.tramos_categoria"
                :item-text="returnTramoLabel"
                item-value="id"
                label="Categoria Vehiculo"
                append-icon="fas fa-caret-down"
                return-object
              ></v-select>
          </v-card-text>
          <v-card-text v-if="categoria !== '' && categoria !== 'porDefinir' && usuario.activoTramos">
            <p><b>Precio Servicio: </b> ${{ getPriceCategory() }} </p>
            <p><b>Descuento: </b> ${{ getDiscount() }} </p>
            <p><b>Precio Final: </b>${{ getFinalPrice() }} </p>
          </v-card-text>
          <v-btn color="red darken-1" flat @click="dialogCloneService = false">Cerrar</v-btn>
          <v-btn color="blue darken-1" flat @click="cloneRequest">Repetir Pedido</v-btn>
          </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDocumentos" max-width="600px">
        <v-card>
          <v-card-title>
            <v-toolbar color="#1f97b9" dark>
              <v-toolbar-title>Documentos del servicio</v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-card-text v-if="pedido.docCliente">
            <div>
              <p>Documentos Cliente: </p>
              <div v-for="(documento, index) in pedido.docCliente" :key="index">
                <v-btn  color="primary" @click="viewDoc(documento)">Ver Documento {{ index + 1}} </v-btn>
              </div>
            </div>
            <br>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text v-else>
            <p><b>Aun no se dispone de documentos.</b></p>
          </v-card-text>
          <v-card-text v-if="pedido.servicePhotos">
            <div>
              <br>
              <p>Documentos de servicio: </p>
              <div v-for="(documento, index) in pedido.servicePhotos" :key="index">
                <p>Documento: {{ documento.nombre }}</p><v-btn flat color="primary" @click="viewDoc(documento.url)">Ver Archivo</v-btn>
              </div>
            </div>
            <br>
            <v-divider></v-divider>
          </v-card-text>
          <v-card-text v-else>
            <p><b>Aun no se disponen de documentos de servicio.</b></p>
          </v-card-text>
          <v-card-text v-if="servicePhotos && servicePhotos.servicePhotos">
            <div>
              <br>
              <p>Documentos de servicio: </p>
              <div v-for="(documento, index) in servicePhotos.servicePhotos" :key="index">
                <p>Documento: {{ documento.nombre }}</p><v-btn flat color="primary" @click="viewDoc(documento.url)">Ver Archivo</v-btn>
              </div>
            </div>
            <br>
            <v-divider></v-divider>
          </v-card-text>
          <v-btn color="blue darken-1" flat @click="dialogDocumentos = false">Cerrar</v-btn>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-snackbar
			v-model="messageContact.show"
			:color="messageContact.type"
			right
			:timeout="4000"
			top>
			{{ messageContact.text }}
			<v-btn
				color="white"
				flat
				@click="messageContact.show = false">
				Ok
			</v-btn>
		</v-snackbar>
  </v-container>
</template>
<script>
  import * as firebase from 'firebase/app'
  import 'firebase/auth'
	import 'firebase/firestore'
  import LoadingLogo from '../../helpers/LoadingLogo'

  export default {
    components: {
			LoadingLogo
		},
    filters: {
			dateFromTimestamp: function(timestamp) {
        let formattedDate = ''
        if (timestamp.seconds) {
          formattedDate = timestamp.toDate().toLocaleString()
        } else {
          formattedDate = new Date(timestamp).toLocaleString()
        }
        return formattedDate
      }
    },
    data () {
      return {
        textCorreoNuevo: '',
        newCorreo: false,
        addCC: false,
        markerOptions: {
          url: require('../../assets/static/img/van.png'),
          size: { width: 45, height: 30, f: 'px', b: 'px' },
          scaledSize: { width: 45, height: 30, f: 'px', b: 'px' }
        },
        pedido: {},
        dialogDetallesCliente: false,
        headers: [
          {text: 'NS', sortable: false, align: 'center', width: "50px"},
          {text: 'Estado', sortable: false, align: 'center', width: "50px"},
          {text: 'Fecha Servicio', sortable: false, align: 'center', width: "50px"},
          /* {text: 'Origen', sortable: false, align: 'center', width: "50px"}, */
          {text: 'Destino', sortable: false, align: 'center', width: "50px"},
          {text: 'Valor Servicio', sortable: false, align: 'center', width: "50px"},
          {text: 'Estado Pago', sortable: false, align: 'center', width: "50px"},
          {text: 'Factura', sortable: false, align: 'center', width: "50px"},
          {text: 'Documentos', sortable: false, align: 'center', width: "50px"},
          {text: 'Repetir', sortable: false, align: 'center', value: 'id', width: "50px"},
          /* {text: 'Datos y progreso', sortable: false, align: 'center', value: 'id'}, */
        ],
        dias: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'],
        table: '',
        fleteExists: false,
        mudanzaExists: false,
        fletes:[],
        mudanzas: [],
        messageContact: {
          show: false,
          type: '',
          text: ''
        },
        items: [
          { title: 'Mis Datos'},
          { title: 'Mis Mudanzas'},
          { title: 'Mis Fletes'}
        ],
        cambiaContrasena: false,
        show: false,
        right: null,
        usuario: null,
        selected: 'Mis Datos',
        editarDatos: false,
        data: null,
        checkCorreo: false,
        rules: {
          required: [value => !!value || 'Campo obligatorio'],
          min: [v => v.length >= 8 || 'Mínimo 8 caracteres'],
          emailRules: [
						v => !!v || 'Campo obligatorio',
						v => {
							const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
							if(re.test(v)){
                this.checkCorreo = true
								return true
							}
							return 'Verifica que el email sea válido'
						}
					]
        },
        dialogCloneService: false,
        fecha: '',
        hora: '',
        menu: undefined,
        horas: ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45'],
        today: new Date().toISOString().substr(0, 10),
        loadingPedido: true,
        mantenedores: {},
        categoria: '',
        servicePhotos: {},
        fleteProvisorioID: '',
        precioConvenio: 0,
        cloneDescription: '',
        dialogDocumentos: false,
      }
      
    },
    mounted () {
      this.getMantenedores()
      this.getUser()
    },
    methods: {
      saveCorreoExtra() {
        const here = this
        const db = firebase.firestore()
        const sesion = here.$store.state.idCliente
        here.usuario.correoCopia.push(this.textCorreoNuevo)
        const data = {
          correoCopia: this.usuario.correoCopia
        }
        db.collection('users').doc(sesion).update(data).then(function() {
          here.textCorreoNuevo = ''
          here.newCorreo = false
          here.addCC = false
        
          here.messageContact.show = true
          here.messageContact.type = 'success'
          here.messageContact.text = 'Se ha añadido un nuevo correo como receptor'
          
        })
      },
      addCCClose() {
        this.textCorreoNuevo = ''
        this.newCorreo = false
        this.addCC = false
      },
      deleteCorreo(correo, index) {
        const here = this
        const db = firebase.firestore()
        const sesion = here.$store.state.idCliente
        this.usuario.correoCopia.splice(index, 1)
        console.log(this.usuario.correoCopia)
        const data = {
          correoCopia: this.usuario.correoCopia
        }
        db.collection('users').doc(sesion).update(data)
      },
      setState(pedido) {
        let estadoCliente = ''
        if (pedido.progreso && pedido.progreso.length > 0) {
          switch (pedido.progreso.length) {
            case 1:
                estadoCliente = 'En proceso'
              break;
            case 2:
                estadoCliente = 'En proceso'
              break;
            case 3:
                estadoCliente = 'Finalizado'
              break;
            default:
              break;
          }
        } else {
          switch (pedido.estado) {
            case 'Registrado':
                estadoCliente = 'Agendado'
              break;
            case 'En espera':
                estadoCliente = 'Cotizar'
              break;
            case 'Enviado a cliente':
                estadoCliente = 'Cotizado'
              break;
            default:
              break;
          }
        }
        
        return estadoCliente
      },
      async openDocs(id) {
        const here = this
        const db = firebase.firestore()
        this.pedido = {}
        this.servicePhotos = {}
        await db.collection('fletes_dev').doc(id).get().then(function(pedido) {
          const data = pedido.data()
          if (data) {
            here.pedido = data
          }
        })
        await db.collection('pedidos').doc(id).get().then(function(doc) {
          const data = doc.data()
          if (data) {
            here.servicePhotos = data
          }
        })
        this.dialogDocumentos = true
      },
      otherWayToClone(pedido) {
        this.dialogCloneService = true
        this.cloneDescription = this.pedido.mensaje
      },
      prepareCloneService() {
        this.dialogCloneService = true
        this.cloneDescription = this.pedido.mensaje
      },
      getCategory(cat) {
        console.log(cat)
        let categoria
        console.log(this.mantenedores)
        this.mantenedores.tramos_categoria.forEach(function(doc) {
          if (cat === doc.id) {
            categoria = doc.category
          }
        })
        return categoria
      },
      async getServicePhotos(id) {
        const db = firebase.firestore()
        const here = this
        await db.collection('pedidos').doc(id).get().then(function(doc) {
          const data = doc.data()
          console.log(data)
          if (data) {
            here.servicePhotos = data
          }
        })
      },
      getFinalPrice() {
        const here = this
        let precioFinal = 0
        let precioCalculo = 0
        this.mantenedores.tramos_categoria.forEach(function(tramos) {
          if (tramos.id === here.categoria.id) {
            precioFinal = tramos.convenio_values.precio
            precioCalculo = tramos.convenio_values.precio
          }
        })
        if (this.usuario.descuento && this.usuario.tipoCliente === 'Convenio') {
          let sobreDescuento = 0
          if (this.usuario.descuentoEspecial) {
            this.usuario.descuentoEspecial.forEach(function(doc) {
              if (doc.category === here.categoria.id) {
                sobreDescuento = doc.descuento
              }
            })
          }
          here.precioConvenio = ((100 - (here.usuario.descuento + sobreDescuento) )/ 100) * precioCalculo
          precioFinal = this.toThousandFilter(((100 - (here.usuario.descuento + sobreDescuento) )/ 100) * precioFinal)
          return precioFinal
        } else {
          return precioFinal
        }
      },
      getDiscount() {
        const here = this
        let descuento = 0
        if (this.usuario.descuento && this.usuario.tipoCliente === 'Convenio') {
          let sobreDescuento = 0
          let precio = 0
          if (this.usuario.descuentoEspecial) {
            this.usuario.descuentoEspecial.forEach(function(doc) {
              if (doc.category === here.categoria.id) {
                sobreDescuento = doc.descuento
              }
            })
          }
          this.mantenedores.tramos_categoria.forEach(function(tramos) {
            if (tramos.id === here.categoria.id) {
              precio = tramos.convenio_values.precio
              descuento = here.toThousandFilter(Math.round(((here.usuario.descuento + sobreDescuento) / 100) * precio))
            }
          })
        }

        return descuento
      },
      getPriceCategory() {
        const here = this
        let precio = 0
        this.mantenedores.tramos_categoria.forEach(function(tramos) {
          if (tramos.id === here.categoria.id) {
            console.log(tramos)
            precio = here.toThousandFilter(tramos.convenio_values.precio)
          }
        })
        console.log(precio)
        return precio
      },
      returnTramoLabel(item){
	    	const index = this.mantenedores.tramos_categoria.findIndex(function(element){
	    		return element.category == item.category
	    	})
	      let label = ''
	      if(index !== this.mantenedores.tramos_categoria.length){
	        label = this.mantenedores.tramos_categoria[index].category
	      }
	      return label
	    },
      getMantenedores() {
        const here = this
        const db = firebase.firestore()
        db.collection('mantenedores').doc('mantenedores').get().then(function(doc) {
          here.mantenedores = doc.data()
          const datos = {
            category: 'Por Definir',
            id: 'porDefinir'
          }
          here.mantenedores.tramos_categoria.push(datos)
        }).catch(function(error) {
          console.log(error)
        })
      },
      sendForm(fleteID, data) {
        const here = this
        const db = firebase.firestore()
        const dataPost = {
          id: fleteID
        }
        db.collection('fletes_dev').doc(fleteID).update(dataPost)
            const contactFormEmail = firebase.functions().httpsCallable('contactFormEmail')
            contactFormEmail({
              nombre: data.usuario.nombre,
              email: data.usuario.email,
              telefono: data.usuario.telefono,
              destino: here.pedido.direcciones.destino,
              origen: here.pedido.direcciones.origen,
              observaciones: data.mensaje,
              imagenes: data.imagenes,
              fecha: here.fecha + ' ' + here.hora,
              fleteID: fleteID,
              pedidoConvenio: data.pedidoConvenio,
              hora: here.hora
            }).then(({dataReturn}) => {
              // this.getDistanceMatrix() //va a hacer el calculo de distancia necesario para el la funcion asigntruck de functions. luego de ello da el paso al save_flete()
              here.messageContact.show = true
              here.messageContact.type = 'success'
              here.messageContact.text = 'Se ha enviado correctamente el mensaje, nos pondremos en contacto contigo a la brevedad.'
              here.dialogCloneService = false
              db.collection('fletes_dev').doc(fleteID).get().then(function(doc) {
                const data = doc.data()
                data.id = doc.id
                data.nsFormateado = 'F.'+ data.NS.c_day + '.' + data.NS.c_general + '.' + data.NS.date
                here.fletes.push(data)
                here.sortFletes(false)
                here.dialogDetallesCliente = false
                here.loadingPedido = false
              })
            })
      },
      async cloneRequest() {
        this.loadingPedido = true
        const here = this
        const db = firebase.firestore()
        const data = {
          fromPreCotizacion: true,
          basicoValue: this.pedido.basicoValue,
          cargos: [],
          completoValue: {},
          created: firebase.firestore.FieldValue.serverTimestamp(),
          datoPagos: [],
          datosDireccion: {
            destino: {
              mover: '',
              numero: 0,
              piso:0,
              tipo:''
            },
            origen: {
              mover: '',
              numero: 0,
              piso:0,
              tipo:''
            }
          },
          descuentos: [],
          direcciones: {
            destino: this.pedido.direcciones.destino,
            origen: this.pedido.direcciones.origen
          },
          distancia:{},
          elementos: [
            {
              alto: 1,
              ancho: 1,
              cat: '',
              descripcion: 'Generico',
              largo: 1,
              metros: 1,
              nombre: 'Generico',
              peso: 1,
              qty: 1
            }],
          estado: 'En espera',
          fecha: this.fecha,
          hora: this.hora,
          oferta: {},
          paymentValue: 0,
          servicio: '',
          tiempos: {
            carga: 0,
            distancia: this.pedido.tiempos.distancia
          },
          tipo: 'Flete',
          usuario: {
            nombre: this.pedido.usuario.nombre,
            telefono: this.pedido.usuario.telefono,
            email: this.pedido.usuario.email
          },
          mensaje: this.cloneDescription,
          imagenes: this.pedido.imagenes,
          Fecha_Estimada: '',
          registro: [],
          valorBase: 0,
          clienteID: this.pedido.clienteID,
          pedidoConvenio: true,
          fecha_servicio_obj: new Date(this.fecha + 'T' + this.hora),
          registroCambios: [],
          documento_tributario: {
            documento: this.pedido.documento_tributario.documento,
            boleta: {
              nombre: this.usuario.nombre,
              rut: this.usuario.rut
            },
            factura: {
              ciudad: this.usuario.ciudad,
              comuna: this.usuario.comuna,
              direccion: this.usuario.direccion,
              giroComercial: this.usuario.giroComercial,
              razonSocial: this.usuario.razonSocial,
              rut: this.usuario.rut,
              telefono: this.usuario.telefono
            }
          },
          categoria: '',
          backUpService: false
        }
        if (this.categoria.id !== 'porDefinir' && this.usuario.activoTramos) {
          data.valorBase = this.precioConvenio
          data.categoria = this.categoria.id
        }
        console.log(data)
        await db.collection("fletes_dev").add(data).then(async function(docRef) {
          let fleteID = docRef.id
          var addMessage = db.collection('users').doc(here.pedido.clienteID)
          addMessage.update({
            fletes: firebase.firestore.FieldValue.arrayUnion(fleteID)
          })
          here.messageContact.show = true
          here.messageContact.type = 'success'
          here.messageContact.text = 'Se ha generado con exito el nuevo pedido.'
          if (here.usuario.tipoCliente !== 'Convenio' || !here.usuario.activoTramos) {
            here.sendForm(fleteID, data)
          } else if (here.usuario.activoTramos) {
            let flete = {}
            console.log(fleteID)
            await db.collection('fletes_dev').doc(fleteID).get().then(function(doc) {
                flete = doc.data()
                flete.id = fleteID
                here.fleteProvisorioID = fleteID
                console.log(flete)
                here.getVehiculos(here.categoria, flete)
            })
            
          }
        })
      },
      getVehiculos(categoria, flete) {
        const db = firebase.firestore()
        const here = this
        const arrayVehiculos = []
        db.collection('vehiculos').where('datos.cat_tramo', '==', categoria.id).where('active_duo', '==', true).get().then(function(querySnapshot) {
          if (!querySnapshot.empty) {
            querySnapshot.forEach(function(doc) {
              const data = doc.data()
              data.id = doc.id
              arrayVehiculos.push(data.id)
              here.loadingPedido = true
            })
            console.log(arrayVehiculos)
            here.checkAgenda(arrayVehiculos,flete,categoria)
          } else {
            console.log('No hay vehiculos disponibles')
            const data = {
              estado: 'URGENTE',
              aviso: 'No hay vehiculo segun la categoria solicitada por el cliente, precio del servicio: $' + here.toThousandFilter(flete.valorBase) + '. El cliente ha seleccionado la categoria: ' + categoria.category
            }
            db.collection('fletes_dev').doc(flete.id).update(data)
            here.sendForm(flete.id, flete.pedidoConvenio)
          }
        })
      },
      checkAgenda(arrayVehiculos,flete,categoria) {
        const db = firebase.firestore()
        const here = this
        const start = new Date()
        let gotVehicle = false
        let vehicleID = ''
        for (let index = 0; index < arrayVehiculos.length; index++) {
          const asignTruckCategory = firebase.functions().httpsCallable('asignTruckCategory')
          const data = {
            duracion: categoria.convenio_values.duracion_horas * 60,
            idVehiculo: arrayVehiculos[index],
            fecha: flete.fecha,
            hora: flete.hora,
            documento: 'fletes_dev',
            id: flete.id
          }
          console.log(data)
          asignTruckCategory(data).then(({ data }) => {
            console.log(data)
            if (data) {
              gotVehicle = true
              vehicleID = arrayVehiculos[index]
              index = arrayVehiculos.length
              console.log('Si encontró vehiculo')
            }
            if (index === arrayVehiculos.length && gotVehicle) {
              //agendar vehiculo
              console.log('Encontró y cerró ciclo')
              here.asignarVehiculo(vehicleID, categoria, flete)
            } else if (index === arrayVehiculos.length) {
              const data = {
                estado: 'URGENTE',
                aviso: 'No hay vehiculo segun la categoria solicitada por el cliente, precio del servicio: $' + here.toThousandFilter(flete.valorBase) + '. El cliente ha seleccionado la categoria: ' + categoria.category
              }
              db.collection('fletes_dev').doc(flete.id).update(data)
              here.sendForm(flete.id, flete.pedidoConvenio)
            }
          })
        }
      },
      async asignarVehiculo(idVehiculo, categoria, flete) {
        const here = this
        const db = firebase.firestore()
        let vehiculo
        let conductor
        let transportista
        await db.collection('vehiculos').doc(idVehiculo)
          .get()
          .then(function(doc) {
          if (doc.exists) {
            vehiculo = doc.data()
            vehiculo.id = doc.id
          }
          })
        if (vehiculo) {
          const idConductor = vehiculo.conductor
          const idTransportista = vehiculo.transportista
          await db.collection('conductores').doc(idConductor)
                    .get()
                    .then(function(doc) {
                      if (doc.exists) {
                        conductor = doc.data()
                        conductor.id = doc.id
                      }
                    })
          await db.collection('transportistas').doc(idTransportista)
            .get()
            .then(function(doc) {
              if (doc.exists) {
                transportista = doc.data()
                transportista.id = doc.id
              }
            })
        }
        console.log(vehiculo)
        console.log(conductor)
        console.log(transportista)
        const data = {
          transportista: {
            active_duo: true,
            archivos: vehiculo.archivos,
            conductor: vehiculo.conductor,
            conductor_data: conductor,
            created: firebase.firestore.FieldValue.serverTimestamp(),
            datos: vehiculo.datos,
            disponible: false,
            id: vehiculo.id,
            transportista: transportista.id
          },
          estado: 'Registrado'
        }
        console.log(data)
        console.log(flete)
        await db.collection('fletes_dev').doc(flete.id).update(data)
        flete.transportista = data.transportista
        here.ingresarAgenda(idVehiculo, categoria, flete, conductor)
      },
      async ingresarAgenda(idVehiculo, categoria, flete, conductor) {
            console.log('entra ingresaragenda')
              const here = this
              let tiempo = categoria.convenio_values.duracion_horas * 60
              const data = {
                start: this.$moment(flete.fecha + ' ' + flete.hora).format(),
                end: this.$moment(flete.fecha + ' ' + flete.hora).add(tiempo, 'm').format(),
                startobj: this.$moment(flete.fecha + ' ' + flete.hora).toDate(),
                endobj: this.$moment(flete.fecha + ' ' + flete.hora).add(tiempo, 'm').toDate(),
                title: 'Pedido: ' + flete.id,
                idPedido: flete.id,
                origen: flete.direcciones.origen,
                destino: flete.direcciones.destino,
                usuario: flete.usuario.nombre,
                checked: false,
                aceptado: false,
                created: new Date(),
                type: 2,
                onHold: false
              }
              if (flete.pedidoConvenio) {
                data.type = 3
              }
              console.log('ingresarAgenda')
              console.log(data)
              const db = firebase.firestore()
              await db.collection('vehiculos').doc(idVehiculo).collection('agenda').add(data)
                .then(async function(docRef) {
                  flete.transportista.agenda = docRef.id
                  await db.collection('fletes_dev').doc(flete.id).set(flete, { merge: true })
                  if (here.usuario.tipoCliente === 'Convenio') {
                    const dataPedido = flete
                    const dataCliente = {
                        tipoCliente: here.usuario.tipoCliente,
                        razonSocial: here.usuario.razonSocial
                    }
                    dataPedido.pedidoAutoAgendado = true
                    /* if (flete.estado === 'Registrado') {
                      dataPedido.holdRespuesta = fasle
                      dataPedido.justTransportChange = false
                    } */
                    dataPedido.cliente = dataCliente
                    dataPedido.emailTransporte = conductor.datos.email
                    dataPedido.conductor = conductor.datos.nombres + ' ' + conductor.datos.apellidos
                    dataPedido.precioNeto = flete.valorBase / 1.19
                    dataPedido.comision = categoria.convenio_values.comision
                    dataPedido.condiciones = 'Pedido Convenio'
                    dataPedido.id = flete.id
                    dataPedido.type = 'f'
                    dataPedido.trp = flete.transportista.id
                    dataPedido.comisionTransportista = '$' + here.toThousandFilter(Math.round(dataPedido.precioNeto * ((100 - categoria.convenio_values.comision)/ 100)))
                    dataPedido.fechaServicio = here.$moment(dataPedido.fecha + 'T' + dataPedido.hora).format('dddd, DD/MM/YY')
                    console.log(dataPedido)
                    const cargoLC = firebase.functions().httpsCallable('cargoCuentaCorriente')
                    await cargoLC(dataPedido)
                      .then(({ data }) => {
                        console.log('Transaccion', data)
                        console.log('Antes del descuento')
                        here.cargoCuentaCorriente(flete.valorBase)
                      })
                      .catch(httpsError => {
                        console.log('error: ', httpsError)
                      })
                  }
                })
                .catch(function(error) {
                  console.log(error)
                })
        },
      async cargoCuentaCorriente(valor) {
        const here = this
        const db = firebase.firestore()
        const data = {
          cuentaCorriente: {
            montoMaximo: here.usuario.cuentaCorriente.montoMaximo,
            usado: here.usuario.cuentaCorriente.usado + valor
          }
        }
        await db.collection('users').doc(here.usuario.id).update(data).then(function() {
          here.loadingPedido = false
          here.pedidoEnviado = false
          here.dialogDetallesCliente = false
          here.dialogCloneService = false
          here.loadingPedido = false
          here.sortFletes(true)
          here.messageContact.show = true
          here.messageContact.type = 'success'
          here.messageContact.text = 'Se ha enviado correctamente el mensaje, nos pondremos en contacto contigo a la brevedad.'
        })
      },
      viewDoc(url) {
        var win = window.open(url, '_blank')
        // Cambiar el foco al nuevo tab (punto opcional)
        win.focus()
      },
      viewDetails(pedido) {
        console.log(pedido)
        const here = this
        here.pedido = {}
        here.pedido = pedido
        console.log('=============')
        console.log(here.pedido)
        here.getServicePhotos(here.pedido.id)
        here.dialogDetallesCliente ? here.dialogDetallesCliente = false : here.dialogDetallesCliente = true
      },
      openFactura(url) {
        var win = window.open(url, '_blank')
        // Cambiar el foco al nuevo tab (punto opcional)
        win.focus()
      },
      openWindow(id,clienteID) {
        const url = 'https://www.duoapp.cl/solicitud_flete/' + id + '?uid=' + clienteID
        var win = window.open(url, '_blank')
        // Cambiar el foco al nuevo tab (punto opcional)
        win.focus()
      },
      toThousandFilter(num) {
        return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, '.'))
      },
      erasePassword() {
        this.data.password1 = '',
        this.data.password2 = '',
        this.cambiaContrasena = false
      },
      updatePassword() {
        const here = this
        const db = firebase.firestore()
        var user = firebase.auth().currentUser
        console.log(user)
        if (here.data.password1 != '' && here.data.password1 === here.data.password2) {
          const newPassword = here.data.password1
          user.updatePassword(newPassword).then(function() {
            const data = {
              password: newPassword
            }
            db.collection('users').doc(here.$store.state.idCliente).update(data)
                 .then(() => {
                    here.erasePassword()
                    here.cambiaContrasena = false
                    here.messageContact.show = true
                    here.messageContact.type = 'success'
                    here.messageContact.text = 'Se ha cambiado la contraseña con exito.'
                    
                  })
                  .catch(httpsError => {
                    here.messageContact.show = true
                    here.messageContact.type = 'error'
                    here.messageContact.text = 'Hubo un error al cambiar la contraseña, por favor intenta nuevamente.'
                  })
                
            // Update successful.
          }).catch(function(error) {
            here.messageContact.show = true
            here.messageContact.type = 'error'
            here.messageContact.text = 'Hubo un error al cambiar la contraseña, por favor intenta nuevamente.'
          });
        }
        

      },
      updateInfo() {
        const db = firebase.firestore()
        const here = this
        const sesion = here.$store.state.idCliente
        const data = here.data
        db.collection('users').doc(sesion).update(data)
          .then(function() {
            here.editarDatos = false
            here.messageContact.show = true
            here.messageContact.type = 'success'
            here.messageContact.text = 'Se han actualizado los datos con exito.'
          })
          .catch()
      },
      async getUser() {
        const here = this
        const db = firebase.firestore()
        const sesion = here.$store.state.idCliente
        here.fletes = []
        await db.collection('users').doc(sesion).get().then(async function(doc){
          here.usuario = doc.data()
          here.usuario.id = doc.id
          here.data = here.usuario
          if (!here.usuario.correoCopia) {
            const dataUpdate = {
              correoCopia: []
            }
            await db.collection('users').doc(sesion).update(dataUpdate)
            here.usuario.correoCopia = []
          }
          if (here.usuario.mudanzas && here.usuario.mudanzas.length > 0) {
            here.mudanzaExists = true
            console.log('usuario tiene mudanzas')
            //let info = []
            here.info = await here.usuario.mudanzas.map(async function(doc){
              await db.collection('pedidos').doc(doc).get().then(function(docData) {
                const infoMudanza = docData.data()
                infoMudanza.id = doc
                here.mudanzas.push(infoMudanza)
                // console.log(here.mudanzas)
                return here.mudanzas
              })
              // return info
            })
            /* console.log(info) */
          }
          let contador = 0
          if (here.usuario.fletes && here.usuario.fletes.length > 0) {
            here.fleteExists = true
            let contador = 0
            here.info = await here.usuario.fletes.map(async function(doc){
              await db.collection('fletes_dev').doc(doc).get().then(function(docData) {
                const infoFletes = docData.data()
                infoFletes.id = doc
                infoFletes.nsFormateado = 'F.'+ infoFletes.NS.c_day + '.' + infoFletes.NS.c_general + '.' + infoFletes.NS.date
                if (infoFletes.datoPagos.length >= 1) {
                  let pagado = 0
                  infoFletes.datoPagos.forEach(function(pago) {
                    pagado += parseInt(pago.monto)
                  })
                  if (pagado >= (infoFletes.valorBase * 0.95)) {
                    infoFletes.pagadoTotal = true
                  }
                }
                here.fletes.push(infoFletes)
                contador++
                if (contador === here.usuario.fletes.length) {
                  here.sortFletes(true)
                }
                // console.log(here.mudanzas)
                
                // return here.fletes
              }).catch(function(error) {
                contador++
                console.log(error)
                if (contador === here.usuario.fletes.length) {
                  here.sortFletes(true)
                }
              })
              // return info
            })
            /* console.log(info) */
          } else {
            console.log('no tiene pedidos')
            here.loadingPedido = false
          }
          console.log(here.fletes)
        })
      },
      async sortFletes(starter = false) {
        const here = this
        if (this.fleteProvisorioID !== '') {
          const db = firebase.firestore()
          await db.collection('fletes_dev').doc(here.fleteProvisorioID).get().then(function(doc) {
            const flete = doc.data()
            flete.nsFormateado = 'F.'+ flete.NS.c_day + '.' + flete.NS.c_general + '.' + flete.NS.date
            here.fletes.push(flete)
            here.fletes = here.fletes.sort(function(a, b) {
              return new Date(b.created.seconds) - new Date(a.created.seconds)
            })
            starter ? here.selected = 'Mis Datos' : here.selected = 'Mis Fletes'
            here.loadingPedido = false
          })
        } else {
          this.fletes = this.fletes.sort(function(a, b) {
            return new Date(b.created.seconds) - new Date(a.created.seconds)
          })
          starter ? here.selected = 'Mis Datos' : here.selected = 'Mis Fletes'
          here.loadingPedido = false
        }
      }
    }
  }
</script>
<style>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  margin: auto;
}

td, th {
  border: 1px solid #dddddd;
  text-align: center;
  padding: 8px;
  
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>